var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-3 mr-4",attrs:{"elevation":"1","fab":"","small":""},on:{"click":function($event){_vm.mini = !_vm.mini}}},[_c('v-icon',[_vm._v(" mdi-dots-vertical ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }